import script from "./HomeNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeNotice.vue?vue&type=script&setup=true&lang=js"

import "./HomeNotice.vue?vue&type=style&index=0&id=e16baa4c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e16baa4c"]])

export default __exports__